<template>
  <el-dialog class="el-dialogs" :title="title" :fullscreen="true" :close-on-click-modal="false"
             :visible.sync="visible">
    <el-row :gutter="4" class="h100 borderwa">
      <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']"
              v-loading="showList && treeLoading">
        <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
             @click="showList = !showList"></div>
        <el-tree class="h100 p_all1 treeDisplay" :data="treeData" :props="defaultProps"
                 :expand-on-click-node="false"
                 ref="myTree" node-key="id" highlight-current default-expand-all @node-click="selTreeNode">
        </el-tree>
      </el-col>
      <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
        <div class="el-table-container">
          <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                   @keyup.enter.native="refreshList(1,1)" @submit.native.prevent>
            <el-form-item prop="keyword" label="关键字：">
              <el-input v-model.trim="searchForm.keyword" maxlength="20"
                        placeholder="请输入关键字(限20字)"
                        clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="refreshList(1,1)" size="small"
                         icon="el-icon-search">
                查询
              </el-button>
              <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
          </el-form>
          <div class="p_all1">
            <el-button type="primary" size="small" @click="addData('add')">新增</el-button>
            <el-button type="primary" size="small" @click="addBatchData()">批量新增</el-button>
            <el-button type="primary" size="small" @click="batchEnable(1)">批量启用</el-button>
            <el-button type="primary" size="small" @click="batchEnable(0)">批量禁用</el-button>
            <!--                        <el-button type="primary" size="small" @click="exportData()">导出</el-button>-->
            <el-button type="danger" size="small" @click="deleteData()">删除</el-button>
          </div>
          <el-table
              :data="dataList"
              v-loading="loading"
              @selection-change="selectionChangeHandle"
              size="small" height="100%"
              class="table" ref="multipleTable" row-key='id' border>
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column prop="nodeName" label="节点名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="parentName" label="父节点" show-overflow-tooltip></el-table-column>
            <el-table-column prop="nodeState" label="状态" show-overflow-tooltip>
              <template slot-scope="{row}">
                <el-switch
                    v-model="row.nodeState"
                    active-value="1"
                    @change="setType(row)"
                    inactive-value="0">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="nodeRemark" label="备注" show-overflow-tooltip></el-table-column>
            <el-table-column
                fixed="right"
                label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small"
                           @click="addData('edit',scope.row)">编辑
                </el-button>
                <el-button type="text" size="small"
                           @click="deleteData(scope.row)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                      @pagination="refreshList"/>
        </div>
      </el-col>
    </el-row>
    <node-add ref="nodeAdd" @refresh="searchTree()"></node-add>
    <batch-add ref="batchAdd" @refresh="searchTree()"></batch-add>
  </el-dialog>
</template>

<script>
import NodeAdd from "@/views/modules/academic/academic/learningNode/nodeAdd.vue";
import BatchAdd from "@/views/modules/academic/academic/learningNode/batchAdd.vue";

export default {
  name: "learningNode",
  components: {BatchAdd, NodeAdd},
  data() {
    return {
      title: '节点管理',
      visible: false,
      showList: true,
      treeData: [],
      treeLoading: false,
      defaultProps: {
        children: 'children',
        label: 'nodeName'
      },
      searchForm: {
        id: '',
        keyword: '',
        current: 1,
        size: 20,
      },
      total: 0,

      dataList: [],
      dataListSelect: [],
      loading: false,
      setlectData: {},
    }
  },

  methods: {
    init(row) {
      this.visible = true
      this.showList = true
      this.setlectData = row
      this.searchTree(row)
    },

    // 查询树状数据
    searchTree() {
      this.treeLoading = true
      this.$axios(this.api.academic.knowledgemodelnodeGetByKnowledgeModelId + this.setlectData.id).then(res => {
        if (res.status) {
          this.treeData = [
            {
              id: '',
              nodeName: this.setlectData.modelName,
              children: [],
            }
          ]
          this.treeData[0].children = res.data
          this.$nextTick(() => {
            this.$refs.myTree.setCurrentKey(this.treeData[0].id);
            this.selTreeNode(this.treeData[0])
          });
        }
        this.treeLoading = false
      })
    },

    // 选择树节点
    selTreeNode(val) {
      this.searchForm.id = val.id
      this.refreshList(1, 1)
    },

    // 获取数据列表
    refreshList(type, ressfas) {
      if (type == 1) {
        this.searchForm.current = 1
      }
      if (ressfas) {
        this.$refs.multipleTable.clearSelection()
      }
      this.loading = true
      this.newSearchData = {
        ...this.searchForm,
        knowledgeId: this.setlectData.id,
      }
      this.$axios(this.api.academic.knowledgemodelnodeList, this.newSearchData, 'get').then(data => {
        if (data && data.status) {
          this.dataList = data.data.records
          if (this.dataList.length === 0 && this.searchForm.current > 1) {
            this.searchForm.current--
            this.refreshList()
          }
          this.dataList.map(item => {
            delete item.children
          })
          this.total = parseInt(data.data.total)
          this.loading = false
        } else {
          this.$message.error('查询失败');
        }
      })
    },

    // 多选
    selectionChangeHandle(val) {
      this.dataListSelect = val
    },
    // 重置
    reset() {
      this.dataListSelect = []
      this.$refs.searchForm.resetFields();
      this.refreshList(1, 1)
    },

    //type add新增 edit编辑
    addData(type, row) {
      this.$refs.nodeAdd.init(type, row, this.setlectData, this.searchForm.id)
    },

    //批量新增
    addBatchData() {
      this.$refs.batchAdd.init(this.setlectData)
    },

    //批量启用 1启用 0禁用
    batchEnable(num) {
      if (this.dataListSelect.length == 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      if (num == 0) {
        this.$confirm(`禁用后，节点及节点之下的所有子节点都将同步禁用！`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.setBatchEnable(num)
        })
      } else {
        this.setBatchEnable(num)
      }
    },

    setBatchEnable(num) {
      let ids = this.dataListSelect.map(item => {
        return item.id
      })
      this.$axios(this.api.academic.knowledgemodelnodeBatchUpdate, {
        ids,
        nodeState: num,
      }, 'post').then(data => {
        if (data && data.status) {
          this.$message.success(`${num == 1 ? '启用' : '禁用'}成功`)
          this.refreshList('', 1)
        } else {
          this.$message.error(data.msg)
        }
      })
    },

    //导出
    exportData() {
      if (this.total == 0) {
        this.$message.warning('暂无可导出的数据!')
        return
      }
      let ids = this.dataListSelect.map(item => {
        return item.id
      })
      // this.exportExcel(this.api.academic.knowledgegraphnodeExport, {
      //     ids,
      //     ...this.newSearchData
      // }, '节点管理', 'post')
    },

    //删除
    deleteData(row) {
      let list = row ? [row] : this.dataListSelect
      if (list.length == 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      let statusTrueList = []
      let ids = list.map(item => {
        if (item.nodeState == '1') {
          statusTrueList.push(item)
        }
        return item.id
      })
      if (statusTrueList.length != 0) {
        this.$message.warning('请先禁用后再删除！')
        return
      }
      this.$confirm(`确认删除所选信息？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios(this.api.academic.knowledgemodelnodeRemoveById, {ids}, 'delete').then(data => {
          if (data && data.status) {
            this.$message.success('删除成功')
            this.refreshList('', 1)
            this.searchTree();
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },

    //切换显示状态
    setType(row) {
      row.nodeState = row.nodeState == '1' ? '0' : '1'
      if (row.nodeState == '1') {
        this.$confirm(`禁用后，节点及节点之下的所有子节点都将同步禁用！`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios(this.api.academic.knowledgemodelnodeUpdateById, {
            id: row.id,
            nodeState: row.nodeState == 1 ? 0 : 1,
          }, 'put').then(data => {
            if (data && data.status) {
              this.$message.success('状态修改成功')
              this.refreshList('', 1)
            } else {
              this.$message.error(data.msg)
              this.refreshList('', 1)
            }
          })
        })
      } else {
        this.$axios(this.api.academic.knowledgemodelnodeUpdateById, {
          id: row.id,
          nodeState: row.nodeState == 1 ? 0 : 1,
        }, 'put').then(data => {
          if (data && data.status) {
            this.$message.success('状态修改成功')
            this.refreshList('', 1)
          } else {
            this.$message.error(data.msg)
            this.refreshList('', 1)
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.borderwa {
  border: 4px solid #f7f7f7;
}

.h100i {
  border-right: 4px solid #f7f7f7;
  overflow: hidden;
}

.treeDisplay {
  .el-tree-node__expand-icon {
    display: none !important;
  }

  .treeIcon {
    width: 14px;
    vertical-align: sub;
    margin-right: 5px;
  }

  .label {
    font-size: 12px;
  }
}

//.treeDisplay::-webkit-scrollbar {
//  display: none;
//}
//
//.treeDisplay::-webkit-scrollbar {
//  display: none;
//}

.el-tree {
  min-width: 100% !important;
  display: inline-block !important;
}

.p_r {
  overflow: auto;
}

.el-icon-arrow-left {
  position: fixed !important;
  right: auto !important;
  left: 15% !important;
}
.el-icon-arrow-right{
  position: fixed !important;
  right: auto !important;
  left: .8% !important;
}
</style>
